import { oxgOpenModal, oxgCloseModal, oxgFetchModal, oxgCloseModalAnimated, oxgCreateLoadingOverlay, oxgRemoveLoadingOverlay } from "../../modules/modals"
import { oxgCleanUpAbSessionItems } from "../modules/asset-briefing"

/*
  #ANCHOR Load Formidable Briefing
*/

window.oxgLoadFormidableBriefing = (oxgId)=> {
  oxgCreateLoadingOverlay()

  jQuery.ajax({
    url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint
    type: 'POST',
    data: {
        action: 'oxg_load_formidable_briefing', // WordPress action hook to trigger the PHP function
        data: {
          oxg_id: oxgId
        }
    },
    success: function(response) { 
      if (response.data.message == 'loaded') {
        let draft = response.data.briefing
        console.log(response)
        constructLoadData(draft)
      } else {
        console.log(response.data)
      }
      oxgRemoveLoadingOverlay()
    },
    error: function(xhr, status, error) { 
      console.error('Error saving changes:', error)
      oxgRemoveLoadingOverlay()
    }
  })
}


/*
  #ANCHOR Load Asset Briefing
*/ 

window.oxgLoadBriefing = (briefingId = 0, discardUnsavedChanges = false)=> {
  if(oxgAssetBriefingCurrentSave && oxgAssetBriefingCurrentSave.unsavedChanges && !discardUnsavedChanges) {
    let ducmModal = oxgFetchModal('ducm');
    oxgCloseModal('lbm')
    oxgOpenModal(ducmModal, 'compact', null, null, briefingId)
  } else {
    let hiddenInfo = document.getElementById('oxg-modal-hidden-info-ducm')
    // get briefing id from hidden field, if this function is called from the discard changes modal
    if (hiddenInfo && hiddenInfo.tagName == 'INPUT' && hiddenInfo.value) {
      briefingId = hiddenInfo.value
    }
    if (oxgUserDrafts && briefingId) {

      oxgCreateLoadingOverlay()

      jQuery.ajax({
        url: ajax_obj.ajax_url, // WordPress-specific AJAX endpoint
        type: 'POST',
        data: {
            action: 'oxg_get_briefing', // WordPress action hook to trigger the PHP function
            data: {
              briefing_id: briefingId
            }
        },
        success: function(response) { 
          if (response.data.message == 'loaded') {
            let draft = response.data.briefing
            console.log(response)
            constructLoadData(draft)
          } else {
            console.error(response.data.message)
          }
          oxgRemoveLoadingOverlay()
        },
        error: function(xhr, status, error) { 
          console.error('Error saving changes:', error)
          oxgRemoveLoadingOverlay()
        }
      });

    }
  }
}

const constructLoadData = (draft)=> {
  console.log(draft)
  let content = draft.content
  let saveName = draft.save_name
  let oxgId = draft.oxg_id
  let briefingItems = []
  let briefingMeta = {}
  console.log('content', content, typeof content)
  content = JSON.parse(content)
  console.log('content unpacked:', content)
  let assets = content.assets
  let mainContent = content.main
  if ( typeof content == 'string' ) { content = JSON.parse(content) }
  /*assets.forEach((object, key) => {
    if ('title' in object) {
      briefingMeta.title = object.title
    } else if ('deadline' in object) {
      briefingMeta.deadline = object.deadline
    } else if ('comment' in object) {
      briefingMeta.comment = object.comment
    } else {
      briefingItems.push(object)
    }
  })*/
  oxgCleanUpAbSessionItems()
  oxgAssetBriefingMeta = mainContent ? mainContent : null
  sessionStorage.setItem('oxgAssetBriefingMeta', JSON.stringify(oxgAssetBriefingMeta))
  oxgAssetBriefingItems = assets
  sessionStorage.setItem('oxgAssetBriefingItems', JSON.stringify(oxgAssetBriefingItems))
  oxgAssetBriefingCurrentSave = {
    isActive: true, 
    saveName: saveName, 
    oxgId: oxgId, 
    unsavedChanges: false, 
    updateSessionItem: true
  }
  sessionStorage.setItem('oxgAssetBriefingCurrentSave', JSON.stringify(oxgAssetBriefingCurrentSave))
  window.open(window.location.origin + '/asset-briefing', '_self')
}

/*
  #ANCHOR Init
*/

document.addEventListener('DOMContentLoaded', () => {
  let bodyClasses = document.body.classList
  if ( ['ab1', 'ab2', 'drafts-archive', 'briefings-archive'].some(c => bodyClasses.contains(c)) ) {
    console.log('load briefings script will run')
  }
})